import styled from 'styled-components'

export const Container = styled.main`
  display: flex;
  height: 100%;

  max-height: 100%;
  overflow: hidden;
`
